// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input__slot:before{border-color:rgba(0,0,0,.02)!important}.vue-tel-input{border-radius:12px!important}.vue-tel-input .vti__dropdown{border-radius:12px 0 0 12px!important}.vue-tel-input .vti__input{border-radius:0 12px 12px 0!important}.dialogWrapper .v-card{border-radius:12px!important;overflow:hidden}.dialogWrapper .v-card .v-card__title:first-child{border-radius:12px 12px 0 0}", ""]);
// Exports
module.exports = exports;
